export const OPENING_ROUTE = '/opening';
export const COMPANY_ROUTE = '/company';
export const QUESTION_ROUTE = '/question';
export const PITCH_ROUTE = '/pitch';
